import { useNotifications as _useNotifications } from '@hwm/ui-lib';
import { errorCodesDictionary } from '@shared/dictionaries/errorCodesDictionary';

export const useNotifications = () => {
  const notifications = _useNotifications(errorCodesDictionary());

  return notifications;
};
